export const ALL_GUESTS = 'all';

export const initialSessionsContext = {
    data: [],
    registeredSessions: [],
    filteredData: [],
    filteredGuestSessionsData: [],
    filters: {
        tags: [],
        searchTerm: '',
        dates: [],
        startTimes: [],
        locations: [],
        eventLists: [ALL_GUESTS],
        setTags: null,
        setSearchTerm: null,
        setDates: null,
        setStartTimes: null,
        setLocations: null,
        setEventLists: null,
    },
    uniqueTags: [],
};
